import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../Common/ModalGeneric";
import OvertredelseskoderIleggelserCreateModalContent from "../OvertredelseskoderIleggelseForm";
import OpenModalComponent from "./OpenModalComponent";

import { postOvertredelseskoderIleggelser } from "../../../actions/overtredelseskoderIleggelserActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";

const rules = {
  id: "required;isDigit;minValue=1",
  beskrivelse: "required",
  overtredelseGruppeId: "required",
  belop: "required;isDigit",
  internkode: "required",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isLargerThan=aktivertDato",
  kreverAvstand: "required",
  kreverAutomatinfo: "required",
  kreverBilettnummer: "required",
  kreverUtlopstidBillett: "required",
};

const initState = {
  open: false,
  submitButtonText: "Lagre",
  id: "",
  beskrivelse: "",
  forklaring: "",
  aktivertDato: "",
  deaktivertDato: "",
  kreverAvstand: null,
  kreverAutomatinfo: null,
  kreverBilettnummer: null,
  kreverUtlopstidBillett: null,
  overtredelseGruppeId: 0,
  belop: "",
  aktiv: false,
  overtredelseInternkoder: [],
  validationError: {},
  openDeaktiverConfirm: false,
};

export default function OvertredelseskoderIleggelser() {
  const dispatch = useDispatch();
  const overtredelsegrupper = useSelector((state) => state.overtredelsegrupper);
  const internkoderIleggelser = useSelector(
    (state) => state.internkoderIleggelser,
  );

  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState);
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = () => {
    update({ submitButtonText: "Lagrer..." });
    dispatch(
      postOvertredelseskoderIleggelser({
        id: state.id && Number(state.id),
        beskrivelse: state.beskrivelse,
        forklaring: state.forklaring,
        overtredelseGruppeId: state.overtredelseGruppeId,
        belop: state.belop && Number(state.belop),
        aktivertDato: state.aktivertDato || null,
        deaktivertDato: state.deaktivertDato || null,
        kreverAvstand: state.kreverAvstand,
        kreverAutomatinfo: state.kreverAutomatinfo,
        kreverBilettnummer: state.kreverBilettnummer,
        kreverUtlopstidBillett: state.kreverUtlopstidBillett,
      }),
    )
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isValid() && !state.deaktivertDato) {
      handlePost();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChangeGroupButtons = (e) => {
    const { name, value } = e.target;
    let val = null;
    if (value === "Kreves") val = true;
    else if (value === "Valgfritt") val = false;
    update({ [name]: val });
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Legg til ny overtredelseskode for ileggelser"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={OpenModalComponent}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <OvertredelseskoderIleggelserCreateModalContent
          id={state.id}
          internkoder={internkoderIleggelser}
          overtredelseInternkoder={state.overtredelseInternkoder}
          beskrivelse={state.beskrivelse}
          forklaring={state.forklaring}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          overtredelseGruppeId={state.overtredelseGruppeId}
          overtredelseGrupper={overtredelsegrupper}
          belop={state.belop}
          handleChange={handleChange}
          handleChangeGroupButtons={handleChangeGroupButtons}
          kreverAvstand={state.kreverAvstand}
          kreverBilettnummer={state.kreverBilettnummer}
          kreverAutomatinfo={state.kreverAutomatinfo}
          kreverUtlopstidBillett={state.kreverUtlopstidBillett}
          validationError={state.validationError}
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver overtredelseskode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePost}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere overtredelseskode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}
